module.exports = __webpack_public_path__ + "img/Regionalstelle.bd31e286.svg";